import { render, staticRenderFns } from "./VpsOverview.vue?vue&type=template&id=768f045a&"
import script from "./VpsOverview.vue?vue&type=script&lang=js&"
export * from "./VpsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports